<template>
  <b-col>
    <b-row>
      <b-col cols="12" class="mx-auto mt-4">
        <table class="w-full leading-normal text-gray"
               style="border: solid 1px #dedede;">
          <thead class="bg-gray-pale" >
          <tr>
            <th colspan="12" class="py-2">
              <span class="px-2">Deputy Secretary</span>
            </th>
          </tr>
          </thead>
          <tbody>
             <LegalPersonsDetails v-if="getCompanyDeputySecretary != null && getCompanyDeputySecretary.data" class="p-1" :persons="[getCompanyDeputySecretary.data]"/>
             <tr v-else>
               <td colspan="12" class="text-center py-4 text-xs text-gray">
                 No deputy secretary found
               </td>
             </tr>
          </tbody>
        </table>
      </b-col>
    </b-row>
  </b-col>
</template>

<script>
import {mapGetters} from "vuex";
import LegalPersonsDetails from "@/views/home/services/registry/business/files/tabs/company_data/LegalPersonsDetails";

export default {
  name: "CompanyDeputySecretary",
  components: {LegalPersonsDetails},
  computed:{
    ...mapGetters(["getCompanyDeputySecretary"])
  }
}
</script>

<style scoped>

</style>
